/*
 * air-video.js — background <video> hydration + in-view autoplay for converted PDPs.
 * Replaces Replo runtime video src injection on pages that no longer load replo-head.
 * Loaded before page-specific scripts; idempotent.
 */
(function () {
  if (window.AirVideo && window.AirVideo.__ready) return;

  /* Play as soon as any pixel of the observe target enters the viewport. */
  var VIDEO_IO_OPTS = { rootMargin: '0px', threshold: 0 };
  /* Optional near-viewport preload — load() only; play() stays on VIDEO_IO_OPTS. */
  var VIDEO_PRELOAD_IO_OPTS = { rootMargin: '200px 0px 200px 0px', threshold: 0 };
  /* Inner video data-rid → visible feature shell (never a distant section / bottom anchor). */
  var VIDEO_OBSERVE_ROOT = {
    '01c3ead5-3e6b-4d0f-90f2-144f189d65ce': '29da58dc-c99f-4219-8de1-7de81c69902c',
    'f0db6c4f-110e-4895-87be-3d76d31f7c55': 'a6e3f897-2dd0-4f5e-86cc-3a370b3e57c3',
    '19cd9fa2-a780-4cd0-803b-89e7d9d22c9c': '000dd9f8-80a0-4930-8032-17d5406dff7b',
    '88b587ec-06b1-41a0-a19a-f4a82fd74d75': '000dd9f8-80a0-4930-8032-17d5406dff7b',
    '9f2f1d7c-732f-44cf-adc6-9ff9ae89b311': 'f9eeddb8-83ab-46a6-bf53-afbaeb76a58c'
  };
  var NO_LOOP_RIDS = { 'f0db6c4f-110e-4895-87be-3d76d31f7c55': true };

  var AIR_HERO =
    'https://cdn.shopify.com/videos/c/o/v/84b928aff6b24765aca5dec6d87ef707.mp4';

  var SHOPIFY_VIDEOS = {
    e3b23617:
      'https://cdn.shopify.com/videos/c/vp/de102256923a4ca89612b138e7966e5f/de102256923a4ca89612b138e7966e5f.SD-480p-0.9Mbps-88074824.mp4',
    v8e770766:
      'https://cdn.shopify.com/videos/c/vp/bb295111a71045cfb6bb430713340051/bb295111a71045cfb6bb430713340051.SD-480p-0.9Mbps-88074820.mp4',
    c7c2f97b:
      'https://cdn.shopify.com/videos/c/vp/94ec31a0b32d440fa41a096a7aa3b349/94ec31a0b32d440fa41a096a7aa3b349.SD-480p-0.9Mbps-88074818.mp4',
    v7ef105c8:
      'https://cdn.shopify.com/videos/c/vp/4ffabae1d6d343efb8aa963596b9974c/4ffabae1d6d343efb8aa963596b9974c.SD-480p-0.9Mbps-88074819.mp4',
    v12397b35:
      'https://cdn.shopify.com/videos/c/vp/af1fe91b83cd4cccaaa7bc418bd85262/af1fe91b83cd4cccaaa7bc418bd85262.SD-480p-0.9Mbps-88074821.mp4',
    vc301e51c:
      'https://cdn.shopify.com/videos/c/vp/82044a7fde784dfc813a501c39ee0ed6/82044a7fde784dfc813a501c39ee0ed6.SD-480p-0.9Mbps-88074822.mp4',
    v85db198b:
      'https://cdn.shopify.com/videos/c/vp/d5cf69d1ed21457da56268e62e18285c/d5cf69d1ed21457da56268e62e18285c.SD-480p-0.9Mbps-88074825.mp4',
    v85db198b_hq:
      'https://cdn.shopify.com/videos/c/vp/480250f6f5ca4463b61892dbab304c51/480250f6f5ca4463b61892dbab304c51.SD-480p-0.9Mbps-88222750.mp4',
    v8c5ea81b:
      'https://cdn.shopify.com/videos/c/vp/5f67ae30d44c4a3190167f6175b58a41/5f67ae30d44c4a3190167f6175b58a41.SD-480p-0.9Mbps-88077226.mp4',
    vaef1dc20:
      'https://cdn.shopify.com/videos/c/vp/13ef1757bcb843d79dfa476e67683238/13ef1757bcb843d79dfa476e67683238.SD-480p-0.9Mbps-88077227.mp4',
    vc719ccdc:
      'https://cdn.shopify.com/videos/c/vp/1a65f6e2e575423086292749a2fccd8d/1a65f6e2e575423086292749a2fccd8d.SD-480p-0.9Mbps-88077228.mp4',
    v2522682c:
      'https://cdn.shopify.com/videos/c/vp/20a04b3955b64224bc44588f4c8c9dd2/20a04b3955b64224bc44588f4c8c9dd2.SD-480p-0.9Mbps-88220290.mp4',
    v738afa65:
      'https://cdn.shopify.com/videos/c/vp/a986acd088b440529c4e6b595d96f782/a986acd088b440529c4e6b595d96f782.SD-480p-0.9Mbps-88221445.mp4'
  };

  var POSTER_BY_RID = {
    '897336a5-3461-4d24-9ef6-2f3a3ae8d803':
      'https://cdn.shopify.com/s/files/1/0771/1762/0499/files/poster-85db198b-hq.jpg?v=1783337549',
    'f0db6c4f-110e-4895-87be-3d76d31f7c55':
      'https://cdn.shopify.com/s/files/1/0771/1762/0499/files/poster-2522682c.jpg?v=1783335371',
    '8be5ab00-803f-43af-8989-3d40491f85f5':
      'https://cdn.shopify.com/s/files/1/0771/1762/0499/files/poster-8c5ea81b.jpg?v=1783112348',
    '9f2f1d7c-732f-44cf-adc6-9ff9ae89b311':
      'https://cdn.shopify.com/s/files/1/0771/1762/0499/files/poster-aef1dc20.jpg?v=1783112348',
    '0d169445-e591-4319-b622-7b8139b57221':
      'https://cdn.shopify.com/s/files/1/0771/1762/0499/files/poster-c719ccdc.jpg?v=1783112348'
  };

  var VIDEO_BY_RID = {
    '897336a5-3461-4d24-9ef6-2f3a3ae8d803': SHOPIFY_VIDEOS.v85db198b_hq,
    'cc63d48c-11ab-4ebd-8d62-52ac4f99c2d2': SHOPIFY_VIDEOS.e3b23617,
    'f36830a7-7359-4a6c-8f3d-b68a13cb0387': SHOPIFY_VIDEOS.v738afa65,
    'f0db6c4f-110e-4895-87be-3d76d31f7c55': SHOPIFY_VIDEOS.v2522682c,
    '01c3ead5-3e6b-4d0f-90f2-144f189d65ce': SHOPIFY_VIDEOS.v7ef105c8,
    '19cd9fa2-a780-4cd0-803b-89e7d9d22c9c': SHOPIFY_VIDEOS.vc301e51c,
    '88b587ec-06b1-41a0-a19a-f4a82fd74d75': SHOPIFY_VIDEOS.v85db198b,
    'd26f8c3b-cb21-48bb-9591-02d78d4ccc1c': SHOPIFY_VIDEOS.v12397b35,
    'fb06afa7-967a-4ca6-aa1b-d8f999415357': SHOPIFY_VIDEOS.v12397b35,
    '9f2f1d7c-732f-44cf-adc6-9ff9ae89b311': SHOPIFY_VIDEOS.vaef1dc20,
    '8be5ab00-803f-43af-8989-3d40491f85f5': SHOPIFY_VIDEOS.v8c5ea81b,
    '0d169445-e591-4319-b622-7b8139b57221': SHOPIFY_VIDEOS.vc719ccdc,
    '1c475665-a614-4e3f-acdf-7126e164aa12': AIR_HERO,
    '7c342622-e516-4f3f-8198-dcbf09900acf': AIR_HERO
  };

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(list, fn) {
    Array.prototype.forEach.call(list || [], fn);
  }

  function isInView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
  }

  function normalizeSrc(src) {
    if (!src) return src;
    if (src.indexOf('assets.replocdn.com') !== -1 && SHOPIFY_VIDEOS) {
      var uuid = (src.match(/\/([a-f0-9-]{36})(?:\?|$)/) || [])[1];
      if (uuid) {
        var key = uuid.split('-')[0];
        if (uuid.indexOf('e3b23617') === 0) return SHOPIFY_VIDEOS.e3b23617;
        if (uuid.indexOf('8e770766') === 0) return SHOPIFY_VIDEOS.v8e770766;
        if (uuid.indexOf('c7c2f97b') === 0) return SHOPIFY_VIDEOS.c7c2f97b;
        if (uuid.indexOf('7ef105c8') === 0) return SHOPIFY_VIDEOS.v7ef105c8;
        if (uuid.indexOf('12397b35') === 0) return SHOPIFY_VIDEOS.v12397b35;
        if (uuid.indexOf('c301e51c') === 0) return SHOPIFY_VIDEOS.vc301e51c;
        if (uuid.indexOf('85db198b') === 0) return SHOPIFY_VIDEOS.v85db198b;
        if (uuid.indexOf('8c5ea81b') === 0) return SHOPIFY_VIDEOS.v8c5ea81b;
        if (uuid.indexOf('aef1dc20') === 0) return SHOPIFY_VIDEOS.vaef1dc20;
        if (uuid.indexOf('c719ccdc') === 0) return SHOPIFY_VIDEOS.vc719ccdc;
        if (uuid.indexOf('2522682c') === 0) return SHOPIFY_VIDEOS.v2522682c;
        if (uuid.indexOf('738afa65') === 0) return SHOPIFY_VIDEOS.v738afa65;
      }
    }
    return src;
  }

  function prepVideo(video) {
    if (!video) return;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.playsInline = true;
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
  }

  function hidePlayOverlay(video) {
    if (!video) return;
    var scope =
      video.closest('[data-replo-carousel] [data-rid]') || video.closest('[data-rid]');
    if (!scope) return;
    each(
      scope.querySelectorAll(
        '.r-1nuyhun, .r-zikq1v, [role="button"] svg[aria-label="Play"]'
      ),
      function (el) {
        var node =
          el.tagName === 'svg'
            ? el.closest('[role="button"]') || el.parentElement
            : el;
        if (node) node.style.display = 'none';
      }
    );
  }

  function videoVisible(video) {
    if (!video) return false;
    var r = video.getBoundingClientRect();
    return r.width > 40 && r.height > 40 && r.bottom > 0 && r.top < (window.innerHeight || 0);
  }

  function tryPlayVideo(video) {
    if (!video) return;
    var src = video.getAttribute('src') || video.currentSrc;
    if (!src) return;
    prepVideo(video);
    hidePlayOverlay(video);
    var playPromise = video.play && video.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  function videoPlayTarget(video) {
    var node = video.closest('[data-rid]');
    if (!node) return video;
    var rid = node.getAttribute('data-rid') || '';
    var outerRid = VIDEO_OBSERVE_ROOT[rid];
    if (outerRid) {
      var outer = document.querySelector('[data-rid="' + outerRid + '"]');
      if (outer) return outer;
    }
    return node;
  }

  function wirePreloadObserver(video, playTarget, src) {
    if (!src || video.getAttribute('src') || !('IntersectionObserver' in window)) return;
    var preloadIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        if (!video.getAttribute('src')) {
          video.setAttribute('src', src);
          try {
            video.load();
          } catch (err) {}
        }
        preloadIo.disconnect();
      });
    }, VIDEO_PRELOAD_IO_OPTS);
    preloadIo.observe(playTarget);
  }

  function wireVideo(video, src, poster) {
    if (!video) return;
    src = normalizeSrc(src);
    var existing = video.getAttribute('src');
    if (existing) {
      var normalized = normalizeSrc(existing);
      if (normalized !== existing) video.setAttribute('src', normalized);
      src = normalized || src;
    }
    if (video.__airVideoWired) {
      if (src && !video.getAttribute('src')) {
        video.setAttribute('src', src);
        try {
          video.load();
        } catch (err) {}
      }
      if (poster && !video.getAttribute('poster')) video.setAttribute('poster', poster);
      if (isInView(videoPlayTarget(video)) || videoVisible(video)) tryPlayVideo(video);
      return;
    }
    video.__airVideoWired = true;
    if (src && !video.getAttribute('src')) {
      video.setAttribute('src', src);
      try {
        video.load();
      } catch (err) {}
    }
    if (poster && !video.getAttribute('poster')) video.setAttribute('poster', poster);
    prepVideo(video);
    var container = video.closest('[data-rid]');
    var rid = (container || {}).getAttribute('data-rid') || '';
    if (!NO_LOOP_RIDS[rid]) {
      if (!video.hasAttribute('loop')) video.setAttribute('loop', '');
      if (!video.hasAttribute('autoplay')) video.setAttribute('autoplay', '');
    }
    video.addEventListener('playing', function () {
      hidePlayOverlay(video);
      if (!NO_LOOP_RIDS[rid]) return;
      var wrap = video.parentElement;
      var still = wrap && wrap.querySelector('.r-1en6tul, .r-39d0wc');
      if (still) still.style.display = 'none';
    });
    hidePlayOverlay(video);
    var playTarget = videoPlayTarget(video);
    var kickPlay = function () {
      if (videoVisible(video) || isInView(playTarget)) tryPlayVideo(video);
    };
    video.addEventListener('loadeddata', kickPlay);
    video.addEventListener('canplay', kickPlay);
    video.__airVideoInit = kickPlay;
    wirePreloadObserver(video, playTarget, src);
    if (!('IntersectionObserver' in window) || reducedMotion) {
      tryPlayVideo(video);
      return;
    }
    if (isInView(playTarget) || videoVisible(video)) tryPlayVideo(video);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) tryPlayVideo(video);
        else if (!videoVisible(video)) video.pause();
      });
    }, VIDEO_IO_OPTS);
    io.observe(playTarget);
  }

  function initBackgroundVideos(scope, extraMap) {
    var root = scope || document;
    var map = extraMap || {};
    for (var k in VIDEO_BY_RID) {
      if (Object.prototype.hasOwnProperty.call(VIDEO_BY_RID, k)) map[k] = map[k] || VIDEO_BY_RID[k];
    }
    each(root.querySelectorAll('[data-rid]'), function (node) {
      var rid = node.getAttribute('data-rid');
      var src = map[rid];
      var poster = POSTER_BY_RID[rid];
      if (!src && !poster) return;
      each(node.querySelectorAll('video'), function (video) {
        if (video.closest('[data-rid]') !== node) return;
        wireVideo(video, src, poster);
      });
    });
    each(Object.keys(map), function (rid) {
      var node = root.querySelector('[data-rid="' + rid + '"]');
      if (!node) return;
      var video = node.querySelector('video');
      if (!video || video.__airVideoWired) return;
      wireVideo(video, map[rid], POSTER_BY_RID[rid]);
    });
    each(root.querySelectorAll('[data-rid] video[src]'), function (video) {
      if (!video.__airVideoWired) wireVideo(video, normalizeSrc(video.getAttribute('src')), null);
    });
    each(root.querySelectorAll('video[autoplay]:not([src])'), function (video) {
      if (!video.__airVideoWired) {
        var rid = (video.closest('[data-rid]') || {}).getAttribute('data-rid');
        if (rid && map[rid]) wireVideo(video, map[rid], POSTER_BY_RID[rid]);
      }
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  window.AirVideo = {
    __ready: true,
    VIDEO_BY_RID: VIDEO_BY_RID,
    SHOPIFY_VIDEOS: SHOPIFY_VIDEOS,
    POSTER_BY_RID: POSTER_BY_RID,
    normalizeSrc: normalizeSrc,
    prepVideo: prepVideo,
    tryPlayVideo: tryPlayVideo,
    wireVideo: wireVideo,
    initBackgroundVideos: initBackgroundVideos
  };

  ready(function () {
    initBackgroundVideos(document);
  });
})();
